import { render } from "./EditReason.vue?vue&type=template&id=de770a3e&scoped=true"
import script from "./EditReason.vue?vue&type=script&lang=js"
export * from "./EditReason.vue?vue&type=script&lang=js"

import "./EditReason.vue?vue&type=style&index=0&id=de770a3e&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de770a3e"]])

export default __exports__